import { takeLatest, put, all, call } from 'redux-saga/effects';
import { encryptData } from '../../_common/enode-decode';
import AlertManager from '../../../utils/alertManager';
import {
	getMemberAccountReportDetailsForSavingsFailure,
	getMemberAccountReportDetailsForFixedDepositFailure,
	getMemberAccountReportDetailsForFixedDepositResponseChanged,
	getMemberAccountReportDetailsForFixedDepositSuccess,
	getMemberAccountReportDetailsForSavingsResponseChanged,
	getMemberAccountReportDetailsForSavingsSuccess,
} from './member-account-report.action';
import MemberAccountReportTypes from './member-account-report.types';
import {
	memberAccountDetailsSavingsGet,
	memberAccountDetailsFixedDepositGet,
} from './member-account-report.services';
/** ***************** GET MEMBER ACCOUNT REPORT DETAILS FOR SAVINGS START *********************** */
export function* getMemberAccountReportForSavings({ payload }: any) {
	try {
		const key = 'GetMemberAccountReportForSavingsKey';
		const { companyID, databaseName, fromDate, toDate, dateType } = payload;
		const jsonData = {
			CompanyID: companyID,
			DatabaseName: databaseName,
			FromDate: fromDate,
			ToDate: toDate,
			SearchType: dateType,
		};
		const encodeData = encryptData(jsonData, key);
		// @ts-ignore
		const responseData = yield call(memberAccountDetailsSavingsGet, encodeData);
		// Check for 401 token validation error
		if (responseData.data.statusCode === '401') {
			// Show token validation alert
			AlertManager.showTokenValidationAlert();
			return;
		} else if (responseData.data.statusCode === '100') {
			yield put(getMemberAccountReportDetailsForSavingsFailure(responseData.data));
		} else {
			yield put(getMemberAccountReportDetailsForSavingsSuccess(responseData.data));
		}
	} catch (error) {
		yield put(getMemberAccountReportDetailsForSavingsFailure(error));
	}
}

export function* resetGetMemberAccountReportForSavingsResponse() {
	yield put(getMemberAccountReportDetailsForSavingsResponseChanged());
}

export function* onGetMemberAccountReportForSavingsDetails() {
	yield takeLatest(
		MemberAccountReportTypes.GET_MEMBER_ACCOUNT_REPORT_SAVINGS_START,
		getMemberAccountReportForSavings,
	);
}

export function* onGetMemberAccountReportResponseForSavingsReset() {
	yield takeLatest(
		MemberAccountReportTypes.GET_MEMBER_ACCOUNT_REPORT_SAVINGS_RESPONSE_RESET,
		resetGetMemberAccountReportForSavingsResponse,
	);
}
/** ***************** GET MEMBER ACCOUNT REPORT DETAILS FOR SAVINGS END *********************** */

/** ***************** GET MEMBER ACCOUNT REPORT DETAILS FOR FIXED DEPOSIT START *********************** */
export function* getMemberAccountReportForFixedDeposit({ payload }: any) {
	try {
		const key = 'GetMemberAccountReportForFixedDepositKey';
		const { companyID, databaseName, fromDate, toDate, dateType } = payload;
		const jsonData = {
			CompanyID: companyID,
			DatabaseName: databaseName,
			FromDate: fromDate,
			ToDate: toDate,
			SearchType: dateType,
		};
		const encodeData = encryptData(jsonData, key);
		// @ts-ignore
		const responseData = yield call(memberAccountDetailsFixedDepositGet, encodeData);
		// Check for 401 token validation error
		if (responseData.data.statusCode === '401') {
			// Show token validation alert
			AlertManager.showTokenValidationAlert();
			return;
		} else if (responseData.data.statusCode === '100') {
			yield put(getMemberAccountReportDetailsForFixedDepositFailure(responseData.data));
		} else {
			yield put(getMemberAccountReportDetailsForFixedDepositSuccess(responseData.data));
		}
	} catch (error) {
		yield put(getMemberAccountReportDetailsForFixedDepositFailure(error));
	}
}

export function* resetGetMemberAccountReportForFixedDepositResponse() {
	yield put(getMemberAccountReportDetailsForFixedDepositResponseChanged());
}

export function* onGetMemberAccountReportForFixedDepositDetails() {
	yield takeLatest(
		MemberAccountReportTypes.GET_MEMBER_ACCOUNT_REPORT_FIXED_DEPOSIT_START,
		getMemberAccountReportForFixedDeposit,
	);
}

export function* onGetMemberAccountReportResponseForFixedDepositReset() {
	yield takeLatest(
		MemberAccountReportTypes.GET_MEMBER_ACCOUNT_REPORT_FIXED_DEPOSIT_RESPONSE_RESET,
		resetGetMemberAccountReportForFixedDepositResponse,
	);
}
/** ***************** GET MEMBER ACCOUNT REPORT DETAILS FOR FIXED DEPOSIT END *********************** */
export function* memberAccountReportSaga() {
	yield all([
		call(onGetMemberAccountReportForSavingsDetails),
		call(onGetMemberAccountReportResponseForSavingsReset),
		call(onGetMemberAccountReportForFixedDepositDetails),
		call(onGetMemberAccountReportResponseForFixedDepositReset),
	]);
}
